/**
 * Arrows for the mega menu "Top Products" promo row. Each promo row is
 * independent, so everything is resolved relative to the clicked button.
 */
(function () {
  if (window.__navigationPromoBound) return;
  window.__navigationPromoBound = true;

  function trackFor(node) {
    return node.closest('.navigation-promo')?.querySelector('[data-navigation-promo-track]') || null;
  }

  function updateArrows(promo) {
    const track = promo.querySelector('[data-navigation-promo-track]');
    const prev = promo.querySelector('[data-navigation-promo-scroll="prev"]');
    const next = promo.querySelector('[data-navigation-promo-scroll="next"]');
    if (!track || !prev || !next) return;

    const maxScroll = track.scrollWidth - track.clientWidth;
    const atStart = track.scrollLeft <= 1;
    const atEnd = track.scrollLeft >= maxScroll - 1;
    if (prev.disabled !== atStart) prev.disabled = atStart;
    if (next.disabled !== atEnd) next.disabled = atEnd;
  }

  function updateAll() {
    document.querySelectorAll('.navigation-promo').forEach(updateArrows);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-navigation-promo-scroll]');
    if (!button) return;

    event.preventDefault();
    const track = trackFor(button);
    if (!track) return;

    const slide = track.querySelector('.navigation-promo__slide');
    const step = slide ? slide.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
    track.scrollBy({ left: button.dataset.navigationPromoScroll === 'prev' ? -step : step, behavior: 'smooth' });
  });

  document.addEventListener(
    'scroll',
    (event) => {
      if (event.target instanceof Element && event.target.hasAttribute('data-navigation-promo-track')) {
        const promo = event.target.closest('.navigation-promo');
        if (promo) updateArrows(promo);
      }
    },
    true
  );

  // The mega menu is hidden until hovered, so widths are only measurable once
  // it opens.
  document.addEventListener('mouseover', (event) => {
    if (event.target instanceof Element && event.target.closest('.mega-menu--container')) updateAll();
  });

  window.addEventListener('resize', updateAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll, { once: true });
  } else {
    updateAll();
  }
})();
